import React from "react";

import { countryToFlag } from "common/utils/utility";
import { CommonAutocomplete } from "./CommonAutocomplete";

export const CountryAutocomplete = ({ id, values, ...props }: any) => (
  <CommonAutocomplete
    {...props}
    id={id}
    values={values}
    showIcon={!!values[id]}
    getIcon={countryToFlag}
  />
);
